module.exports = __webpack_public_path__ + "static/media/Serpent_meat.9eeeb322.png";